var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalableFlexible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 42.4264,
    width: 59,
    height: 39,
    rx: 19.5,
    transform: "rotate(-45 0.707107 42.4264)",
    fill: "#F3FAFF",
    stroke: "#CEECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 26.625H42.375M42.375 26.625V31.875M42.375 26.625L32.3125 36.6875M37.5625 36.6875H32.3125M32.3125 36.6875V31.4375",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.625 26.625H27.5C27.2679 26.625 27.0454 26.7172 26.8813 26.8813C26.7172 27.0454 26.625 27.2679 26.625 27.5V41.5C26.625 41.7321 26.7172 41.9546 26.8813 42.1187C27.0454 42.2828 27.2679 42.375 27.5 42.375H41.5C41.7321 42.375 41.9546 42.2828 42.1187 42.1187C42.2828 41.9546 42.375 41.7321 42.375 41.5V35.375",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalableFlexible);
export default __webpack_public_path__ + "static/media/Scalable & Flexible.3bed842a9e30be8ce945bb393cf9b73f.svg";
export { ForwardRef as ReactComponent };